import {Presenter, View} from "./contract";
import {Injectable} from "@angular/core";
import {ApiProvider} from "../../providers/api/api";

@Injectable()
export abstract class BasePresenter implements Presenter
{
    view: View;

    constructor(private api: ApiProvider)
    {

    }

    /**
     * Contacts the api and attempts to update the RFC
     * @param {string} rfcId
     * @param {string} rfcStatus
     * @param {string} noteFromVendor
     * @param rfcCompletionDate
     * @returns {Subscription}
     */
    updateRfc(rfcId: string, rfcStatus: string, noteFromVendor: string, vendorId: string, rfcCompletionDate: any = null, creditRefNo: string = null)
    {
        // These two fields are required
        if (rfcId && rfcStatus)
        {
            this.view.showLoader();
            return this.api.updateRfc({
                rfcId, rfcStatus, noteFromVendor, rfcCompletionDate, creditRefNo, vendorId
            })
            .subscribe(res =>
            {
                // Show Success
                this.view.showMessage("Thank you, the request has been successfully submitted");
                this.view.navigate("SubmittedPage");
                // TODO Now what do we do?

            }, err =>
            {
                // Show Error
                this.view.showError("Error", "There was an error updating the RFC");
                this.view.hideLoader();
                console.log("Error updating RFC");

            }, () =>
            {
                this.view.hideLoader();
            })
        }
        else
        {
            // Require fields werent presented
            this.view.showError("Error", "The RFC has an invalid id");
        }

    }

    /**
     * Set the view that this presenter is used by
     * @param {View} view
     */
    setView(view: View)
    {
        this.view = view;
    }

}



// WEBPACK FOOTER //
// ./src/pages/base/presenter.ts